import type { BookEventSlotPayload } from "./book-event.type";

import { bookEventEndpoint } from "../endpoints";
import { convertToDTOAttendees } from "./book-event.helpers";

export async function bookEventSlot(payload: BookEventSlotPayload) {
  const attendees = convertToDTOAttendees(payload.attendees);

  const response = await fetch(bookEventEndpoint, {
    method: "POST",
    body: JSON.stringify({ ...payload, attendees }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    return response.json();
  }

  return response.json();
}
